export enum VehicleType {
	Car = 'Car',
	Motorcycle = 'Motorcycle',
	Boat = 'Boat',
}
